import { apiFetch } from '../../shared/api/httpClient';
import { clientHeaders } from '../../shared/lib/device';

// GET /api/config/support (public, no auth — the Help tab renders before
// login). Field names mirror SupportConfigController's JSON verbatim.
export type SupportConfig = {
  business_email: string;
  telegram_channel_url: string;
};

export function fetchSupportConfig(): Promise<SupportConfig> {
  return apiFetch('/api/config/support', {
    headers: { ...clientHeaders() },
  });
}
